<template>
  <div class="periodicFunctionality">
    <box :title="$t('search')">
      <div class="">
        <monthly-date-picker  @getDate="getFunctionality" />
      </div>
    </box>
    <div class="py-2">
      <PeriodWork :periodWork="periodWork" />
    </div>
  </div>
</template>

<script>
import PeriodWork from "../../components/functionality/period/PeriodWork.vue";
import Box from "../../components/widget/Box.vue";
import EosToastType from "../../model/EosToastType";
export default {
  components: {
    PeriodWork,
    Box,
  },

  data() {
    return {
      periodWork: {},
    };
  },
  methods: {
    getFunctionality(year, month) {
      if (year == {} || month == "") {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("msg-empty-date-err"),
        });

        return;
      }

      this.periodWork = {};

      const params = new URLSearchParams();
      params.append("month", month);
      params.append("year", year);

      this.$store
        .dispatch("GetPersonMonthWork", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            var data = [];
            data = result.data;
            if (data.length > 0) {
              this.periodWork = data[0];
              this.periodWork.year = year;
              // var moment = require("jalali-moment");
              // var nowMonth = moment().locale("fa").format("MM");
              // this.periodWork.period =parseInt(nowMonth.replace("0",""));
              this.periodWork.period =month;
              this.periodWork.isPeriod = false;
            }
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
    },
  },
};
</script>

<style scoped>
.v-text-field__details {
  display: none;
}
</style>